export default __webpack_public_path__ + "static/media/tandoori.e8fed906.jpg";